import React from 'react';

const LoadingOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg text-center">
        <div className="flex flex-col items-center">
          <img src="/loading.gif" alt="Loading..." className="w-16 h-16" />
          <p className="mt-4 text-gray-700 dark:text-gray-300">載入中...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay; 